module.exports = __webpack_public_path__ + "img/user_default.497c58f9.png";